import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';
import { Options } from '@/components/Common/Selects/Select.types';

export type CouponFormValues = {
  discountType?: string;
  package?: Options[];
  code?: string;
  value?: number;
  usageLimit?: number;
  expirationDate?: string;
};

const couponValidationSchema = (
  mode: 'create' | 'update',
  type: 'FIXED' | 'PERCENT',
) =>
  yup.object({
    discountType: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) =>
          schema.required('Veuillez sélectionner le type du coupon'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('DiscountType'),

    package: yup
      .array()
      .of(
        yup.object().shape({
          _id: yup.string().required(),
          name: yup.string().required(),
        }),
      )
      .when([], {
        is: () => mode === 'create',
        then: (schema) =>
          schema
            .min(1, 'Veuillez sélectionner au moins un package.')
            .required('Le package est obligatoire'),
        otherwise: (schema) => schema.notRequired(),
      }),

    code: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.required('Veuillez saisir le code promo'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Code'),

    value: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .required('Veuillez saisir la valeur du code promo')
      .when([], {
        is: () => type === 'PERCENT',
        then: (schema) =>
          schema
            .min(0.1, 'La valeur doit être au moins 0.1%')
            .max(100, 'La valeur ne peut pas dépasser 100%'),
      })
      .positive('La valeur doit être un nombre positif.')
      .label('Value'),

    usageLimit: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .when([], {
        is: () => mode === 'create',
        then: (schema) =>
          schema
            .required('Veuillez saisir la limite d’usage.')
            .positive('La valeur doit être un nombre positif.'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('UsageLimit'),

    expirationDate: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) =>
          schema.required("Veuillez saisir la date d'expiration."),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('ExpirationDate'),
  });

export const useHandleCouponForm = (
  mode: 'create' | 'update',
  type: 'FIXED' | 'PERCENT',
) => {
  const { register, handleSubmit, errors, setValue, reset } =
    useFormHandler<CouponFormValues>(couponValidationSchema(mode, type));
  return {
    register,
    handleSubmit,
    setValue,
    errors,
    reset,
  };
};
